// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"6f581c0f","332":"8f07ec41","404":"10d4c20e","675":"a7441d0c","743":"0215e39b","847":"b8d25e5b"}[chunkId] + ".chunk.js";
};